"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackStackDepth = void 0;
let maxStackDepth = 0;
/**
 * Tracks the current stack depth by temporarily increasing V8's stack trace limit.
 * This gives us a more accurate measurement of actual stack depth.
 * Note: This is a temporary solution and should be used carefully as it can impact performance.
 */
const trackStackDepth = (location) => {
    // Save current limit
    const originalLimit = Error.stackTraceLimit;
    try {
        // Temporarily increase limit to get full stack
        Error.stackTraceLimit = Infinity;
        const stack = new Error().stack;
        const depth = stack?.split('\n').length ?? 0;
        if (depth > maxStackDepth) {
            maxStackDepth = depth;
            // eslint-disable-next-line no-console
            console.log(`New max stack depth: ${depth} at ${location}`);
        }
    }
    finally {
        // Restore original limit
        Error.stackTraceLimit = originalLimit;
    }
};
exports.trackStackDepth = trackStackDepth;
